module.exports = __webpack_public_path__ + "media/audio26.482af56a.wav";